import { getUA } from 'react-device-detect';
import { stringExistsIn } from 'MODULES/validations';

export const hideContentFromUserAgent = () => /inspectiontool|inspection|adsense|google-safety|googleother|bot|googlebot|crawler|spider|robot|crawling/i.test(getUA) || stringExistsIn('hide', window.location);
